<p-toast></p-toast>
<p-confirmDialog rejectButtonStyleClass="p-button-outlined"></p-confirmDialog>
<app-top-bar [topBarTitle]="topBarTitle"></app-top-bar>
<div class="bpt-main-content-container" *ngIf="isScreenAccessible; else screenNotAccessible" style="overflow: auto">
    <div class="card">
        <div class="flex flex-column card-container">
            <div class="mb-1">
                <app-action-item-search [enableCheckBoxes]="enableCheckBoxes"></app-action-item-search>
            </div>
        </div>
    </div>
</div>

<ng-template #screenNotAccessible>
    <app-error [errorMessage]="errorMessage"></app-error>
</ng-template>